import { useGetInvoicesSummary } from 'api/invoices/use-get-invoices-summary';
import { UserRole, withRoleGuard } from 'shared/hocs/with-role-guard.tsx';
import { useInvoiceFiltersStore } from 'shared/stores';
import { numberFormatter } from 'shared/utils/numbers/formatter';
import { ListSummary } from 'components/common/list-summary';

const InvoicesSummaryComponent = () => {
  const { filters, search } = useInvoiceFiltersStore();
  const { data, isLoading } = useGetInvoicesSummary({ search, filters });

  return (
    <ListSummary isLoading={isLoading}>
      Income count: {numberFormatter(data?.incomeInvoicesCount || 0)} / Total income:{' '}
      {numberFormatter(data?.totalIncomeAmount || 0)}€
    </ListSummary>
  );
};

export const InvoicesSummary = withRoleGuard(InvoicesSummaryComponent, [
  UserRole.admin,
  UserRole.assistant,
  UserRole.accountant,
]);
